import { inputInitState } from "./init_state";
import * as ActionTypes from "../actions/action_type";

const initialStete = {
  stores: {
    data: inputInitState,
  },
};
export const change_item_view_info = (state = initialStete, action) => {
  switch (action.type) {
    case ActionTypes.getChangeItemViewSuccessAction: {
      return { ...state, stores: action.payload };
    }
    case ActionTypes.getChangeItemViewFailAction:
    case ActionTypes.getChangeViewResetAction:
      return { ...state, stores: initialStete.stores };
    default:
      return state;
  }
};
